import React, {  } from "react";
// another components
// styled components
import { Image, Button} from "antd";
// models
import EscudoAlcaldiaBlanco from "../../../../assets/landing/medellin.png";
import jsPDF from 'jspdf';
import { PDF_PW, PDF_MG, PDF_CW, PDF_LABEL_W } from '../../../../utils/pdfPage';

interface IProps {
  postulacion: any;
  lineasConvocatoria: any;
}

export const FormularioInscripcion: React.FC<IProps> = (props: IProps) => {
  const imprimir = async () => {
    const p = props.postulacion;
    const PW = PDF_PW, MG = PDF_MG, CW = PDF_CW;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const str = (v: any) => (v == null ? '' : String(v));

    // Logo
    let logoBase64 = '';
    try {
      const src = EscudoAlcaldiaBlanco as unknown as string;
      if (src.startsWith('data:')) {
        logoBase64 = src;
      } else {
        const blob = await fetch(src).then(r => r.blob());
        logoBase64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    } catch { /* logo no disponible */ }

    let y = MG;

    // Cabecera
    const HEADER_H = 22;
    pdf.setFillColor(240, 240, 240);
    pdf.rect(MG, y, CW, HEADER_H, 'F');
    if (logoBase64) {
      try {
        const fmt = logoBase64.startsWith('data:image/jpe') ? 'JPEG' : 'PNG';
        pdf.addImage(logoBase64, fmt, MG + 2, y + 2, 18, 12);
      } catch { /* logo no disponible */ }
    }
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    pdf.text('SECRETARÍA DE CULTURA CIUDADANA', PW / 2, y + 9, { align: 'center' });
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    pdf.text('CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA', PW / 2, y + 16, { align: 'center' });
    y += HEADER_H + 6;

    // Campos
    const LBL_W = PDF_LABEL_W;
    const VAL_X = MG + LBL_W + 4;
    const VAL_W = CW - LBL_W - 4;
    const LH = 4.5;
    const ROW_PAD = 2;
    const tipoMap: Record<string, string> = { '1': 'Persona Natural', '2': 'Persona Jurídica', '3': 'Grupo Conformado' };

    const fields: ({ label: string; value: string } | null)[] = [
      { label: 'Código', value: str(p.radicado) },
      { label: 'Nombre de la propuesta', value: str(p.nombre_propuesta) },
      { label: 'Línea convocatoria', value: str(p.linea_convocatoria) },
      { label: 'Categoría', value: str(p.categoria_linea_convocatoria) },
      { label: 'Tipo de participante', value: tipoMap[str(p.tipo_participante)] || '' },
      null,
      { label: 'Nombre del participante / representante', value: str(p.nombre_participante || p.nombre_representante) },
      { label: 'Documento identificación', value: str(p.numero_documento_participante) },
    ];

    pdf.setFontSize(9);
    for (const field of fields) {
      if (!field) {
        pdf.setDrawColor(180, 180, 180);
        pdf.line(MG, y, MG + CW, y);
        y += 5;
        continue;
      }
      pdf.setFont('helvetica', 'bold');
      const lblLines = pdf.splitTextToSize(field.label + ':', LBL_W);
      pdf.setFont('helvetica', 'normal');
      const valLines = pdf.splitTextToSize(field.value, VAL_W);
      const rowH = Math.max(lblLines.length, valLines.length) * LH + ROW_PAD * 2;

      const textY = y + ROW_PAD + LH * 0.8;
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(80, 80, 80);
      pdf.text(lblLines, MG, textY);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(0, 0, 0);
      pdf.text(valLines, VAL_X, textY);
      y += rowH;
    }

    pdf.save(`${str(p.radicado)}.pdf`);
  };

  return (
      <div
        id="modal_custom"
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div className="container-fluid border bg-light p-4">
          <div className="row">
            <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%"}} preview={false} />
            <br />
            <br />
            <span className="md-title-text text-center font-size-16px">
              <br />
              SECRETARÍA DE CULTURA CIUDADANA
            </span>
            <br />
            <span className="md-title-text text-center font-size-16px">
              CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
            </span>
          </div>
        </div>
        <div className="row">
          <br />
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Código:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.radicado}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Nombre de la propuesta:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.nombre_propuesta}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Línea convocatoria:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.linea_convocatoria}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Categoría:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.categoria_linea_convocatoria}
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Tipo de participante:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.tipo_participante == '3' ? 'Grupo Conformado' : ''}
            {props.postulacion.tipo_participante == '2' ? 'Persona Jurídica' : ''}
            {props.postulacion.tipo_participante == '1' ? 'Persona Natural' : ''}
          </div>
        </div>
        <hr />
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Nombre del participante / representante:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante ? props.postulacion.nombre_participante : props.postulacion.nombre_representante }
          </div>
        </div>
        <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div
            className="col-4 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingLeft: "16px" }}
          >
            Documento identificación:
          </div>
          <div className="col-6 font-size-14px font-family-Montserrat-Regular">
            {props.postulacion.numero_documento_participante}
          </div>
        </div>
        <div id="footer"></div>
        <div className="col-2 text-center">
          <Button className="form_bg_btn button-blanco-radius" onClick={imprimir}>
              Descargar
          </Button>
        </div>
      </div>
  );
};
